import {configureStore as createReduxToolkitStore} from '@reduxjs/toolkit'
import {routerMiddleware} from 'connected-react-router'
import createRootReducer from '../reducers'

const createBrowserHistory = require('history').createBrowserHistory;


export const history = createBrowserHistory();

const routeMiddleware = routerMiddleware(history);

export default function configureStore(preloadedState = {}) {
  return createReduxToolkitStore({
    reducer: createRootReducer(history), // root reducer with router state
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // This app dispatches non-serializable values (e.g. files, moment/date
        // objects) and mutates state directly in places, matching its
        // pre-existing (non-RTK) redux-thunk setup, so keep these checks off
        // to preserve prior behavior rather than surfacing new dev warnings.
        serializableCheck: false,
        immutableCheck: false,
      }).concat(routeMiddleware),
  });
}
